export default __webpack_public_path__ + "bb763a923d16c9ab5acb486a26e784db.svg";